import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'ssnFormat'
})
export class SsnFormatInputPipe implements PipeTransform {

  transform(val: any): any {

    if (val) {
      val = this.format_ssn(val);
    }

    return val;
  }

  format_ssn(val) {

    val = val.replace(/-/g, '');

    const len = val.length;

    if (len <= 3) {
      return val;
    } else if (len >= 4 && len <= 5) {
      return `${val.substr(0, 3)}-${val.substr(3, 2)}`;
    } else if (len >= 6 && len <= 9) {
      return `${val.substr(0, 3)}-${val.substr(3, 2)}-${val.substr(5, len)}`;
    } else {
      return 'Invalid SSN';
    }

  }

}
